<template>
  <label :class="bem.b()" :style="{cursor: disabled ?  'not-allowed' : 'pointer'}">
    <span :class="bem.e('input')">
      <input
        type="checkbox"
        v-model="model"
        ref="inputRef"
        :disabled="disabled"
        :style="{cursor: disabled ?  'not-allowed' : 'unset'}"
        :value="label"
        @change="handleChange"
      />
    </span>
    <span v-if="$slots.default || label" :class="bem.e('label')">
      <slot></slot>
      <template v-if="!$slots.default">
        {{ label }}
      </template>
    </span>
  </label>
</template>

<script setup lang="ts">
import { createNamespace } from '@chenms-demo/utils/create'
import { checkboxEmits, checkboxProps } from './checkbox'
import { computed, onMounted, ref, watch } from 'vue'

const bem = createNamespace('checkbox')
const props = defineProps(checkboxProps)
const emit = defineEmits(checkboxEmits)

defineOptions({
  name: 'cms-checkbox'
})

const model = computed({
  get() {
    return props.modelValue
  },
  set(val: any) {
    emit('update:modelValue', val)
  }
})

const inputRef = ref<HTMLInputElement>()

function indeterminate(val: boolean) {
  inputRef.value!.indeterminate = val
}

function handleChange(e: Event) {
  const target = e.target as HTMLInputElement
  const value = target.checked ? true : false
  emit('change', value)
}

watch(() => props.indeterminte, indeterminate)

onMounted(() => {
  indeterminate(props.indeterminte)
})
</script>

<style scoped></style>
